export default "__VITE_ASSET__CGpNClTf__"